import React, { Component } from "react";
import { connect } from "react-redux";
import { setHomeValue } from "../../../actions";
import { Body } from '../../Common/Form';
import Continue from "../../Common/Continue";
import Text from '../../Common/Form/Text';

import aptoIcon from '../../../assets/icons/icon-apto.png';
import homeIcon from '../../../assets/icons/icon-house.png';
import firstFloorIcon from '../../../assets/icons/icon-first-floor.png';
import secondFloorIcon from '../../../assets/icons/icon-second-floor.png';

class HogarForm_2 extends Component {

  constructor(props) {
    super(props);
    this.getContent = this.getContent.bind(this);
  }

  componentDidMount () {
    const { 
      cleanOptionsSelected
    } = this.props;
    cleanOptionsSelected();
  }

  getContent() {

    const {
      houseType,
      aptoFloors,
      onValueChange,
    } = this.props;

    return (
      <>
        <Text style={{ paddingTop: '25px'}} className="Text-question">
          ¿Cómo es el lugar donde vivís?
        </Text>
        <div className="Hogar-formRow">
          <div
            className="Hogar-options-container"
            onClick={() => { onValueChange('houseType', 'A') }}>
            <div className={`Hogar-option ${houseType === 'A' ? 'Hogar-option-on' : 'Hogar-option-off' }`}>
              <img className="Hogar-option-icon" src={aptoIcon} alt="info" />
              Apartamento
            </div>
          </div>
          <div
            className="Hogar-options-container"
            onClick={() => { onValueChange('houseType', 'H') }}>
            <div className={`Hogar-option ${houseType === 'H' ? 'Hogar-option-on' : 'Hogar-option-off' }`}>
              <img className="Hogar-option-icon" src={homeIcon} alt="info" />
              Casa
            </div>
          </div>
        </div>
        { houseType === 'A' &&
          <>
            <Text style={{ paddingTop: '25px'}} className="Text-question">
              ¿En qué piso vivís?
            </Text>
            <div className="Hogar-formRow">
              <div
                className="Hogar-options-container"
                onClick={() => { onValueChange('aptoFloors', 1) }}>
                <div className={`Hogar-option ${aptoFloors === 1 ? 'Hogar-option-on' : 'Hogar-option-off' }`}>
                  <img className="Hogar-option-icon" src={firstFloorIcon} alt="info" />
                  Primer piso
                </div>
              </div>
              <div
                className="Hogar-options-container"
                onClick={() => { onValueChange('aptoFloors', 2) }}>
                <div className={`Hogar-option ${aptoFloors === 2 ? 'Hogar-option-on' : 'Hogar-option-off' }`}>
                  <img className="Hogar-option-icon" src={secondFloorIcon} alt="info" />
                  Segundo o superior
                </div>
              </div>
            </div>
          </>
        }
      </>
    );
  }

  render() {
    return (
      <div>
        <Body columnContent={this.getContent} />
        <Continue state={true}/>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    houseType: state.home.houseType,
    aptoFloors: state.home.aptoFloors
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: (type, value) => {
      dispatch(setHomeValue(type, value));
    },
    cleanOptionsSelected: () => {
      dispatch(setHomeValue('fireSelected', null));
      dispatch(setHomeValue('theftSelected', null));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HogarForm_2);